import {useQuery} from "@apollo/client";
import {GetProduct} from "./Product.js";

export function useGetProduct(params = {}) {
    const {data, previousData, loading, error, refetch, variables} = useQuery(
        GetProduct,
        {...params, notifyOnNetworkStatusChange: true}
    );
    
    let holder = (data && data['GetProduct']) ? data : previousData;
    const extracted = (holder) ? holder['GetProduct'] : null;

    if(error) console.log(error);

    return {
        data: extracted, 
        loading: (loading && !previousData), 
        refetch, 
        variables,
        error: error
                ? <div className="bg-red-600 text-white px-4 py-2 mt-1 rounded-md">{error?.message}</div>
                : null
    }
}
export async function asyncGetProduct(variables = {}, apolloClient) {
    const {data, loading} = await apolloClient.query({
        query: GetProduct,
        variables
    });
    const extracted = data ? data['GetProduct'] : null;
    return {
        data: extracted,
        loading: loading,
        variables
    }
}
